import { render, staticRenderFns } from "./DashProgressBar.vue?vue&type=template&id=5124d552&"
import script from "./DashProgressBar.vue?vue&type=script&lang=js&"
export * from "./DashProgressBar.vue?vue&type=script&lang=js&"
import style0 from "./DashProgressBar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports